import '@fontsource/barlow-semi-condensed/600.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ErrorBoundary } from './ui/ErrorBoundary';
import { MapWindow } from './ui/MapWindow';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root fehlt');

const params = new URLSearchParams(location.search);
const runId = params.get('run');
const view = params.get('window') === 'map' && runId ? <MapWindow runId={runId} /> : <App />;

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>{view}</ErrorBoundary>
  </StrictMode>,
);
